import type { ComponentStyleConfig } from '@chakra-ui/theme';
import { dls } from '@joinrepublic/dls-ui-core';

/**
 * DLS 2.2 Display — display type: the `title-*` metrics set at regular weight.
 *
 * Single version: `Display` is new in 2.2 and has no 2.1 to coexist with, so this stays a flat
 * file rather than a `display/{index,2.1,2.2}.ts` folder.
 *
 * Each size reads its `textStyle` rather than restating the metrics, so `size="display-400"`
 * and `textStyle="display-400"` cannot drift apart. Only the tracking separates a `display` step
 * from its `title` twin; the weight difference lives in `baseStyle` here.
 */
const step = (name: keyof typeof dls.textStyles) => ({
  ...dls.textStyles[name],
});

export const styleConfig: ComponentStyleConfig = {
  baseStyle: {
    fontWeight: 'normal',
    color: 'neutral.fg-primary',
  },
  sizes: {
    'display-400': step('display-400'),
    'display-500': step('display-500'),
    'display-600': step('display-600'),
    'display-700': step('display-700'),
    'display-800': step('display-800'),
    'display-900': step('display-900'),
  },
  variants: {
    'text-primary': {
      color: 'neutral.fg-primary',
    },
    'text-secondary': {
      color: 'neutral.fg-secondary',
    },
    'text-tertiary': {
      color: 'neutral.fg-tertiary',
    },
    'text-disabled': {
      color: 'neutral.fg-disabled',
    },
  },
  defaultProps: {
    size: 'display-600',
    variant: 'text-primary',
  },
};
